<template>
  <section class="hero-section">
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title">聯絡我們</h1>
      </div>
    </div>
  </section>

  <div class="content-container">
    <!-- 聯絡卡片區塊 -->
    <div class="contact-cards">
      <div class="contact-card">
        <div class="card-icon">
          <i class="fas fa-map-marker-alt"></i>
        </div>
        <h3>公司地址</h3>
        <p>{{ contactInfo.address }}</p>
        <a
          :href="`https://maps.google.com/?q=${encodeURIComponent(
            contactInfo.address,
          )}`"
          target="_blank"
          class="card-link"
        >
          查看地圖
        </a>
      </div>

      <div class="contact-card">
        <div class="card-icon">
          <i class="fas fa-phone-alt"></i>
        </div>
        <h3>聯絡電話</h3>
        <p>{{ contactInfo.phone }}</p>
        <a
          :href="`tel:${contactInfo.phone.replace(/[^0-9]/g, '')}`"
          class="card-link"
        >
          立即撥打
        </a>
      </div>

      <div class="contact-card">
        <div class="card-icon">
          <i class="fas fa-envelope"></i>
        </div>
        <h3>電子郵件</h3>
        <div class="email-wrapper">
          <p>annyoohoh@gmail.com</p>
        </div>
        <a href="mailto:annyoohoh@gmail.com" class="card-link"> 寄送郵件 </a>
      </div>

      <div class="contact-card">
        <div class="card-icon">
          <i class="far fa-clock"></i>
        </div>
        <h3>聯絡表單</h3>
        <p>歡迎聯絡我們</p>
        <button @click="openContactForm" class="card-link">聯絡表單</button>
      </div>

      <div class="contact-card">
        <div class="card-icon">
          <i class="far fa-clock"></i>
        </div>
        <h3>營業時間</h3>
        <p>週一至週五</p>
        <p>9:00 - 18:00</p>
      </div>
    </div>

    <!-- 公司與地圖 -->
    <div class="company-map-section">
      <div class="company-info">
        <div class="company-logo-container">
          <img
            src="@/assets/image/AYH.webp"
            alt="安裕和國際企業社"
            class="company-logo"
          />
        </div>
        <h2 class="company-name">安裕和國際企業社</h2>
        <p class="company-slogan">專業醫療設備 • 品質保證</p>

        <div class="social-connect">
          <h3>社群媒體</h3>
          <div class="social-links">
            <a
              href="https://www.facebook.com/people/%E5%AE%89%E8%A3%95%E5%92%8C/61571369791385/#"
              target="_blank"
              class="social-link"
            >
              <i class="fab fa-facebook-f"></i>
            </a>
            <!-- <a
                href="https://www.instagram.com/yochungmed/"
                target="_blank"
                class="social-link instagram"
              >
                <i class="fab fa-instagram"></i>
              </a> -->
          </div>
        </div>

        <div class="line-connect">
          <h3>Line 客服</h3>
          <div class="line-id">@annyoohoh</div>
          <a href="https://lin.ee/jrA7vQO" target="_blank" class="line-button">
            <i class="fab fa-line"></i> 加入好友
          </a>
        </div>
      </div>

      <div class="map-section-container">
        <div class="map-section">
          <div class="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.198997252784!2d120.34684177599883!3d22.57165943300346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e1cd1879aa43f%3A0xf9e4ab156d22c85!2zODEy6auY6ZuE5biC5bCP5riv5Y2A6aOb5qmf6LevNDc55be3N-iZnw!5e0!3m2!1szh-TW!2stw!4v1761718281468!5m2!1szh-TW!2stw"
              width="100%"
              height="100%"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              title="安裕和國際企業社 Google 地圖"
            ></iframe>
          </div>
        </div>

        <div class="product-section">
          <h2 class="section-title">我們的產品類別</h2>
          <div class="product-grid">
            <div class="product-item">
              <div class="product-icon">
                <i class="fas fa-syringe"></i>
              </div>
              <div class="product-info">
                <h3>耗材管材</h3>
                <p>提供多樣醫療相關耗材、管材，適用於各式臨床與檢查操作</p>
              </div>
            </div>

            <div class="product-item">
              <div class="product-icon">
                <i class="fas fa-stethoscope"></i>
              </div>
              <div class="product-info">
                <h3>設備儀器</h3>
                <p>醫療專業設備，適用於診療、照護與臨床輔助用途</p>
              </div>
            </div>

            <div class="product-item">
              <div class="product-icon">
                <i class="fas fa-apple-alt"></i>
              </div>
              <div class="product-info">
                <h3>營養保健</h3>
                <p>提供營養補充與保健產品，維持身體健康</p>
              </div>
            </div>

            <div class="product-item">
              <div class="product-icon">
                <i class="fas fa-concierge-bell"></i>
              </div>
              <div class="product-info">
                <h3>商品服務</h3>
                <p>多樣化附屬商品與售後服務，提供完整使用體驗</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 聯絡表單模態框 -->
    <ContactForm
      :isVisible="showContactForm"
      @close="closeContactForm"
      @contact-info-updated="fetchContactInfo"
    />
  </div>
</template>

<script src="@/assets/js/contact.js" defer></script>
<style scoped src="@/assets/css/contact.css"></style>
